








import Vue from "vue";

export default Vue.extend({
  name: "Card",
  props: {
    color: {
      type: String,
      default: "var(--tertiary-color)"
    },
    BackgroundColor: {
      type: String,
      default: "var(--secondary-color)"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "100%"
    },
    BorderRadius: {
      type: String,
      default: "0px"
    }
  },
  computed: {
    style() {
      return {
        width: this.width,
        height: this.height,
        borderRadius: this.BorderRadius,
        backgroundColor: this.BackgroundColor,
        color: this.color
      };
    }
  }
});
